var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgICalendarColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.59766,
    y: 5.06836,
    width: 16.8,
    height: 13.7455,
    rx: 2.29091,
    fill: "#81B1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59766 7.35927C3.59766 6.09403 4.62333 5.06836 5.88857 5.06836H18.1067C19.372 5.06836 20.3977 6.09403 20.3977 7.35927V9.65018H3.59766V7.35927Z",
    fill: "#1065D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18262 6.75028V4.30664",
    stroke: "#10141A",
    strokeWidth: 1.52727,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8135 6.75028V4.30664",
    stroke: "#10141A",
    strokeWidth: 1.52727,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgICalendarColor);
export default __webpack_public_path__ + "static/media/i_calendar_color.e6807729c12d389d69abd1776bceea26.svg";
export { ForwardRef as ReactComponent };